import React from "react";
import ProductTemplate from "../../ProductTemplate";
import sd77Cover from "../../../assets/sd77/sd77Cover2.webp";
import sd77a from "../../../assets/sd77/sd77a.webp";
import sd77b from "../../../assets/sd77/sd77b.webp";
import sd771 from "../../../assets/sd77/sd771.webp";
import sd772 from "../../../assets/sd77/sd772.webp";
import sd773 from "../../../assets/sd77/sd773.webp";
import sd774 from "../../../assets/sd77/sd774.webp";
import sd775 from "../../../assets/sd77/sd775.webp";
import sd776 from "../../../assets/sd77/sd776.webp";
import sd777 from "../../../assets/sd77/sd777.webp";
import sd778 from "../../../assets/sd77/sd778.webp";
import sd77sec1 from "../../../assets/sd77/sd77sec1.webp";
import sd77sec2 from "../../../assets/sd77/sd77sec2.webp";
import sd77sec3 from "../../../assets/sd77/sd77sec3.webp";
import sd77sec4 from "../../../assets/sd77/sd77sec4.webp";

const Sd77 = () => {
  const data = {
    title: "ALUMIL SD77",
    subtitle: "SMARTIA SD77 insulated system",
    description:
      "SMARTIA SD77 is ALUMIL’s system for quality entrance doors requiring modern design, high performance, and emphasis on safety. The system provides the ability to create multiple constructions combined either with aluminium panels or with glazing infills. Thanks to its modern, flat, and coplanar design, it offers elegant uniformity that enhances the innovative design and aesthetics of the series.",
    specifications: [
      { label: "THERMAL INSULATION", value: "Yes" },
      { label: "EXTERIOR SHAPES", value: "Flat" },
      { label: "FRAME DEPTH", value: "77 mm" },
      { label: "GLAZING TYPE", value: "Double - Triple" },
      { label: "MAXIMUM GLAZING THICKNESS", value: "from 23 to 59 mm" },
      { label: "MECHANISM", value: "Perimetrical locking mechanism" },
      { label: "SEALING METHOD", value: "Perimetrical at 3 levels with EPDM gaskets" },
      { label: "MINIMUM THRESHOLD HEIGHT", value: "22 mm" },
      { label: "TYPE OF THERMAL INSULATION", value: "Polyamides 40 mm width, ALUMIL Energy bar, Insulation foam" },
      { label: "UW", value: "from 0.7 W/m²K" },
      { label: "WATER TIGHTNESS", value: "CLASS 7A" },
      { label: "AIR PERMEABILITY", value: "CLASS 4" },
      { label: "WIND LOAD RESISTANCE", value: "C4/B4" },
      { label: "BURGLAR RESISTANCE", value: "RC2" },
      { label: "SASH WEIGHT", value: "up to 180 Kg" },
      { label: "UF", value: "from 0.9 up to 1.9 W/m²K" },
      { label: "MINIMUM VISIBLE ALUMINIUM FACE HEIGHT", value: "117 mm" },
      { label: "TYPES OF TYPOLOGY", value: "For all entrance door typologies with glass or aluminium panels" },
    ],
    renders: [sd77Cover, sd77a, sd77b],
    typologies: [
      { image: sd771, caption: "Hinged door inwards/outwards" },
      { image: sd772, caption: "Double leaf door inwards/outwards opening" },
      { image: sd773, caption: "Hinged door with insulation panel" },
      { image: sd774, caption: "Double leaf door with insulation panel" },
      { image: sd775, caption: "Hinged door with insulation panel & fixed pane" },
      { image: sd776, caption: "Hinged door with insulation panel, fixed pane & fanlight" },
      { image: sd777, caption: "Hinged door inwards/outwards with insulation panel & fixed pane" },
      { image: sd778, caption: "Hinged door inwards/outwards with insulation panel, fixed pane & fanlight" },
    ],
    sections: [sd77sec1, sd77sec2, sd77sec3, sd77sec4],
    relatedFiles: [
      {
        label: "SMARTIA Aluminum Systems",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/general/smartia-brochure-gr-en.pdf?sfvrsn=2dc3db89_78",
      },
      {
        label: "SD77 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/pre-qualification-files/supreme/pre-qualification-sd77f4e3a81aba954c1b8c233f00e0788cd4.pdf?sfvrsn=2ebdd2d8_31",
      },
      {
        label: "SD77 Brochure",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/supreme/smartia-sd77-en.pdf?sfvrsn=ead2c007_28",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default Sd77;